<template>
  <div class="block_screen">
    <img class="img-center" src="assets/backup_screens/scr47.png" alt="">
    <a data-name="yes" @click.prevent="changeScreen(106)" class="br-btn42" href=""></a>
    <div class="btn_left">
      <a data-name="back" href="" @click.prevent="changeScreen(104)"
         class="btn btn_orange">Back</a>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import $ from 'jquery'
  export default {
    mounted() {
      setInterval(function(){
        $('.br-btn42').addClass('flash_btn');
      },500);
    },
    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      })
    },
  };
</script>
<style type="text/css">
  .br-btn42 {
    position: absolute;
    top: 374px;
    left: 572px;
    width: 118px;
    height: 30px;
    z-index: 7;
  }
</style>
